import TransactionAnalytics from './TransactionAnalytics';
export default function FinanceReports() { return <TransactionAnalytics kind="finance" title="Finance Analytics" />; }
